import { formatNumber } from './format-number';
import { isNumber } from './is-number';

/**
 * Format a number as a percentage string.
 * @param {number | string} value - The value to format.
 * @param {number} [decimals=2] - The number of decimal places to include.
 * @returns {string} The formatted percentage string.
 *
 *  @example
 * ```typescript
 *   formatPercent(0.1234); // "12.34%"
 *   formatPercent('0.1234'); // "12.34%"
 *   formatPercent(0.1234, 0); // "12%"
 *   formatPercent('invalid'); // ""
 *   formatPercent(0.1234, 3); // "12.340%"
 * ```
 */
export const formatPercent = (value: number | string, decimals = 2): string => {
  let percent: number;

  if (typeof value === 'string') {
    percent = Number(value);

    if (!isNumber(value)) {
      return '';
    }
  } else {
    percent = value;
  }

  return formatNumber(percent, {
    settings: {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    },
    style: 'percent',
  });
};
